import _ from 'lodash';

import { CopilotActions, WebsocketActions } from 'actions/actionTypes';

import Licenses from 'helpers/Licenses';
import env from 'helpers/env';

import { CHAT_CONTEXT_TYPES } from 'constants/copilot';

export const connectSocket = () => dispatch => {
  const host = env.websocketUrl;
  dispatch({ type: WebsocketActions.CONNECT, host });
};

const subscribeMeeting = ({
  dispatch,
  getState,
  meetingUuid,
  streamType,
  entityKey,
  chatUuid = null
}) => {
  const state = getState();

  const subscribed = state.websocket[streamType];
  let alreadySubscribed = false;

  // Unsubscribe from other other meetings
  if (subscribed) {
    Object.keys(subscribed).forEach(uuid => {
      if (subscribed[uuid] && uuid !== meetingUuid) {
        dispatch({
          type: WebsocketActions.UNSUBSCRIBE,
          streamType,
          entityKey,
          uuid,
          chatUuid
        });
      } else if (subscribed[uuid] && uuid === meetingUuid) {
        alreadySubscribed = true;
      }
    });
  }
  if (!alreadySubscribed) {
    dispatch({
      type: WebsocketActions.SUBSCRIBE,
      streamType,
      entityKey,
      uuid: meetingUuid,
      contextType: CHAT_CONTEXT_TYPES.MEETING,
      chatUuid
    });
  }
};

export const subscribeBookmarks = meetingUuid => (dispatch, getState) => {
  const state = getState();

  const hasRealtime = _.includes(
    state.user.features,
    Licenses.FEATURES.realTimeTranscription
  );

  if (!hasRealtime) {
    return;
  }
  subscribeMeeting({
    dispatch,
    getState,
    meetingUuid,
    streamType: WebsocketActions.TYPE_BOOKMARKS,
    entityKey: WebsocketActions.KEY_MEETING
  });
};

export const subscribeBattlecards = meetingUuid => (dispatch, getState) => {
  subscribeMeeting({
    dispatch,
    getState,
    meetingUuid,
    streamType: WebsocketActions.TYPE_BATTLECARDS,
    entityKey: WebsocketActions.KEY_MEETING
  });
};

export const subscribeMeetingRealtimeTranscriptions =
  meetingUuid => (dispatch, getState) => {
    subscribeMeeting({
      dispatch,
      getState,
      meetingUuid,
      streamType: WebsocketActions.TYPE_MEETING_REALTIME_TRANSCRIPTIONS,
      entityKey: WebsocketActions.KEY_MEETING
    });
  };

export const subscribeMeetingMeta = meetingUuid => (dispatch, getState) => {
  subscribeMeeting({
    dispatch,
    getState,
    meetingUuid,
    streamType: WebsocketActions.TYPE_MEETING_META,
    entityKey: WebsocketActions.KEY_MEETING
  });
};

export const unSubscribeToMeeting = meetingUuid => dispatch => {
  const streamTypes = [
    WebsocketActions.TYPE_BOOKMARKS,
    WebsocketActions.TYPE_MEETING_META,
    WebsocketActions.TYPE_BATTLECARDS,
    WebsocketActions.TYPE_MEETING_REALTIME_TRANSCRIPTIONS
  ];

  streamTypes.forEach(streamType => {
    dispatch({
      type: WebsocketActions.UNSUBSCRIBE,
      streamType,
      entityKey: WebsocketActions.KEY_MEETING,
      uuid: meetingUuid
    });
  });
};

// Copilot Actions
export const sendCopilotMessage =
  ({
    chatUuid,
    contextType,
    contextUuid,
    message,
    userPromptUuid,
    additionalContextMentions,
    copilotStandaloneContextPills,
    webSearchEnabled,
    primaryContextLabel
  }) =>
  dispatch => {
    dispatch({
      type: CopilotActions.SEND_COPILOT_MESSAGE,
      streamType: WebsocketActions.TYPE_COPILOT,
      entityKey: WebsocketActions.KEY_COPILOT_CHAT,
      chatUuid,
      contextType,
      contextUuid,
      message,
      userPromptUuid,
      additionalContextMentions,
      copilotStandaloneContextPills,
      webSearchEnabled,
      primaryContextLabel
    });
  };
